import Fire_base from '../../Config/Fire_base'


const LoginController = async (state) => {
    
        let status = {}
        await Fire_base.auth().signInWithEmailAndPassword(state.email, state.password)
        .then(res => {status= res})
        .catch(error=>{status= error})
        return status
}

export default LoginController